import Header from 'components/Header';
import TermsData from 'data/Terms';
import React from 'react';

export default function Terms() {
  return (
    <div className="">
      <Header />
      <main className="main SafetyPage">
        <div className="wrapper">
          <section className="section">
            <div className="section-intro">
              <div className="title">
                <h2>TERMS AND CONDITIONS</h2>
                <br />
                <h2>VERSION 1.6, UPDATED JULY 2021</h2>
                <br />
              </div>
              <p className="body">
                Raven Livestream is a virtual event hosting platform for
                organizations and individuals who want to host events online
                (&quot;Events&quot;). Please read these Terms and Conditions
                (&quot;Terms&quot;, &quot;Terms and Conditions&quot;) carefully
                before using the http://www.ravenlivestream.com website and the
                mobile and PC application (the &quot;Service&quot;) operated by
                Raven Livestream Technologies (&quot;us&quot;, &quot;we&quot;,
                or &quot;our&quot;). Your access to and use of the Service is
                conditioned on your acceptance of and compliance with these
                Terms. These Terms apply to all visitors, users and others who
                access or use the Service. BY ACCESSING OR USING THE SERVICE YOU
                AGREE TO BE BOUND BY THESE TERMS. YOU CONFIRM THAT YOU HAVE
                READ, UNDERSTOOD AND AGREE TO BE BOUND BY THESE USER TERMS BY
                CLICKING THE &quot;ACCEPT&quot; BUTTON BEFORE BEING GRANTED
                ACCESS TO RAVEN LIVESTREAM, OR OTHERWISE WHERE YOU ACCESS OR USE
                RAVEN LIVESTREAM, OR YOU REGISTER AN ACCOUNT WITH US. A LEGALLY
                BINDING CONTRACT BETWEEN YOU AND US WILL THEN BE FORMED (THE
                &quot;USER AGREEMENT&quot;), CONSISTING OF THESE USER TERMS,
                GOVERNING YOUR ACCESS TO AND USE OF RAVEN LIVESTREAM. IF YOU
                DISAGREE WITH ANY PART OF THE TERMS THEN YOU MAY NOT ACCESS THE
                SERVICE. OUR TERMS AND CONDITIONS HAVE BEEN TAILORED TO MEET THE
                REGULATIONS SET BY THE NATIONAL INFORMATION TECHNOLOGY
                DEVELOPMENT AGENCY (NITDA).
              </p>
            </div>

            <div className="privacies">
              {TermsData.map(({ title, body }) => (
                <div className="privacy-card" key={title}>
                  <h3>{title}</h3>
                  <p>{body}</p>
                </div>
              ))}
            </div>
          </section>
        </div>
      </main>
    </div>
  );
}
